import { forwardRef } from 'react';
import { Label } from './Label';
import { Help } from './Help';

export const Input = forwardRef((props, ref) => {
  const { value, label, help, style, ...rest } = props;
  return (
    <div style={{ width: '100%' }}>
      <Label label={label} />
      <Help help={help} />
      <input
        value={value || ''}
        ref={ref}
        {...rest}
        style={{
          border: '1px solid #ccc',
          background: 'white',
          padding: '6px 10px',
          borderRadius: 6,
          boxShadow: '2px 2px #0001',
          fontSize: 14,
          ...style,
        }}
      />
    </div>
  );
});
